module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner1-ec6eb774c004246dbb6ceb2fd3e24c8a.png";